/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Shell from '../../common/components/Shell/Shell';
import { Grid } from '@mui/material';
import LetterGenerationPresenter from './LetterGenerationPresenter';
import { useTranslate } from '../../hooks';
import { useLocation } from 'react-router-dom';

function LetterGenerationController() {
  const { language } = useTranslate();
  const { pathname } = useLocation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          paddingLeft:
            language === 'en' && pathname !== '/empLetterGeneration'
              ? '22em'
              : '6em',
          paddingRight:
            language === 'ar' && pathname !== '/empLetterGeneration'
              ? '7em'
              : '0',
        }}
      >
        <LetterGenerationPresenter />
      </Grid>
    </Shell>
  );
}
export default LetterGenerationController;
